<div class="section section-padding">
    <div class="container">
        <div class="section-title text-center">
            <p class="subtitle">04 --- Services</p>
            <h4 class="title">What We Do</h4>
        </div>
        <div class="row">
            <!-- Data -->
            <div class="col-lg-3 col-md-6" *ngFor="let item of serviceblock | slice:0:4">
                <!-- <a routerLink="/service-details/{{item.id}}" class="sigma_service style-5">
                    <i [class]="item.icon"></i>
                    <div class="sigma_service-body">
                        <span *ngFor="let cat of getCategories(item.category) | slice:0:1">{{cat.title}}</span>
                        <h5>{{item.title}}</h5>
                        <span class="sigma_service-link"> <i class="far fa-plus"></i> </span>
                    </div>
                </a> -->
            </div>
            <!-- Data -->
        </div>
    </div>
</div>